<template>
  <b-container
    class="CarouselSection"
    :class="backgroundClass"
    fluid
  >
    <b-container class="CarouselSection__container">
      <b-carousel
        id="carousel-1"
        :interval="4000"
        indicators
      >
        <b-carousel-slide
          v-for="item in items"
          :key="item.key"
        >
          <template #img>
            <img
              v-if="assetType(item.filename) === 'image' "
              class="d-block img-fluid w-100"
              :src="`${item.filename}/m/1920x1080/smart`"
              alt="image slot"
            >
            <video
              v-if="assetType(item.filename) === 'video'"
              autoplay
              class="d-block img-fluid w-100 CarouselSection__video"
              controls
            >
              <source
                :src="item.filename"
                type="video/mp4"
              >
              Your browser does not support the video tag.
            </video>
          </template>
        </b-carousel-slide>
      </b-carousel>
    </b-container>
  </b-container>
</template>

<script>
export default {
  name : 'CarouselSection',
  props: {
    variant: {
      type   : String,
      default: '',
    },
    items: { type: Array, default: null },
  },
  computed: {
    backgroundClass () {
      return `bg-${this.variant} bg-cover bg-center d-flex`
    },
  },
  methods: {
    assetType (filename) {
      const types = {
        jpg : 'image',
        jpeg: 'image',
        png : 'image',
        gif : 'image',
        mp4 : 'video',
      }
      return types[filename.toLowerCase().split('.').pop()]
    },
  },
}
</script>

<style lang="scss" scoped>
    .CarouselSection {
        &__container {
            padding-top: $spacer * 2;
            padding-bottom: $spacer * 2;
        }

        &__video {
            object-fit: cover;
            height: 20%;
        }
    }
</style>
